<template>
    <v-chart :option="monthlyChartData" ref="monthlyChart" />
</template>
<script>
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { PieChart } from 'echarts/charts';
import {
    TitleComponent, TooltipComponent, LegendComponent, GridComponent, ToolboxComponent,
} from 'echarts/components';
import VChart from 'vue-echarts';

use([CanvasRenderer, PieChart, TitleComponent, TooltipComponent, LegendComponent, GridComponent, ToolboxComponent]);

export default {
    components: {
        VChart,
    },
    props: {
        monthlyData: {
            type: Array,
            default: () => [],
        },
        year: {
            type: Number,
            default: 0,
        },
    },
    watch: {
        monthlyData(newValue) {
            if (newValue !== null) {
                this.updateCharts();
            }
        },
    },
    data() {
        return {
            // 銀行每月存量圖
            monthlyChartData: {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#6a7985',
                        },
                    },
                },
                backgroundColor: 'transparent',
                legend: {
                    data: [],
                },
                toolbox: {},
                grid: {
                    top: '50px',
                    left: '30px',
                    right: '30px',
                    bottom: '30px',
                    containLabel: true,
                },
                xAxis: [
                    {
                        type: 'category',
                        boundaryGap: false,
                        data: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
                    },
                ],
                yAxis: {
                    type: 'value',
                    axisLine: {
                        show: false,
                    },
                },
                series: [],
            },
        };
    },
    mounted() {
        window.addEventListener('resize', this.updateChartSize);
    },
    destroyed() {
        window.removeEventListener('resize', this.updateChartSize);
    },
    methods: {
        updateChartSize() {
            this.$refs.monthlyChart.resize();
        },
        updateMonthlyChart() {
            const bankNames = [];
            const bankMonthlyData = [];
            const monthlySum = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
            const monthlyDepositSum = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
            const monthlyLoanSum = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

            // 各銀行帳戶
            for (var i = 0; i < this.monthlyData.length; i++) {
                const bank = this.monthlyData[i];

                // 1~12月資料
                const monthlyData = [];
                let isEmpty = true;
                for (let j = 0; j < bank.monthlyBankBalanceInfos.length; j++) {
                    const bal = Math.round(bank.monthlyBankBalanceInfos[j].bal);

                    // 加總餘額（for 合併總計)
                    monthlySum[j] += bal;

                    // 加總餘額（for sumup)
                    if (!bank.isBorrower) {
                        monthlyDepositSum[j] += bal;
                    }
                    if (bank.bnK_SNO && bank.isBorrower) {
                        monthlyLoanSum[j] += bal;
                    }

                    if (bal !== 0) isEmpty = false;
                }
            }
            // 加入存款總額
            bankNames.push('當月存款總額');
            bankMonthlyData.push({
                name: '當月存款總額',
                type: 'line',
                areaStyle: {},
                data: monthlyDepositSum,
                itemStyle: {
                    normal: {
                        color: '#00cc00',
                    },
                },
            });

            // 加入借款總額
            bankNames.push('當月借款總額');
            bankMonthlyData.push({
                name: '當月借款總額',
                type: 'line',
                areaStyle: {},
                data: monthlyLoanSum,
                itemStyle: {
                    normal: {
                        color: '#ff9d00',
                    },
                },
            });

            // 合併總計
            bankNames.unshift('合併總計');
            bankMonthlyData.unshift({
                name: '合併總計',
                type: 'line',
                data: monthlySum,
            });

            // 去除今年未到月份
            if (this.year == new Date().getFullYear()) {
                const currMonth = new Date().getMonth();
                for (let s = 0; s < bankMonthlyData.length; s++) {
                    for (i = 0; i < bankMonthlyData[s].data.length; i++) {
                        if (i > currMonth && bankMonthlyData[s].data[i] == 0) {
                            bankMonthlyData[s].data[i] = null;
                        }
                    }
                }
            }

            // 曲線圖重載
            const newChartData = JSON.parse(JSON.stringify(this.monthlyChartData));
            newChartData.legend.data = bankNames;
            newChartData.series = bankMonthlyData;

            this.$refs.monthlyChart.clear();
            this.monthlyChartData = newChartData;
        },
        updateCharts() {
            this.updateMonthlyChart();
        },
    },
};
</script>
